import * as Yup from 'yup'

export const VideoFormValidation = Yup.object({
    title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    link: Yup.string()
        .min(9, 'Vimeo video id should have minimum of 9 digits')
        .required("Vimeo video id is required!"),
})